import { useColorMode } from "@chakra-ui/react";
import React from "react";

type IFrameMessageEventType = {
  type?: string;
  theme?: string;
};

export function ThemeProvider(props: React.PropsWithChildren) {
  const { setColorMode, colorMode } = useColorMode();

  const handleMessage = React.useCallback(
    (e: MessageEvent<IFrameMessageEventType>) => {
      if (e.data?.type && e.data.type === "THEME") {
        if (e.data.theme) {
          const theme = e.data.theme;

          if (theme === "light" || theme === "dark") {
            if (theme !== colorMode) {
              setColorMode(theme);

              const url = new URL(window.location.href);

              url.searchParams.set("theme", theme);

              window.history.replaceState({}, "", url);
            }
          }
        }
      }
    },
    [colorMode, setColorMode],
  );

  React.useLayoutEffect(() => {
    if (window.self !== window.top) {
      window.addEventListener("message", handleMessage);
      window.parent.postMessage({ type: "REQUEST_THEME" }, "*");
    }

    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, [handleMessage]);

  React.useLayoutEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const themeParam = urlParams.get("theme");

    if (themeParam && (themeParam === "light" || themeParam === "dark")) {
      if (themeParam !== colorMode) {
        setColorMode(themeParam);
      }
    }
  }, []);

  return <>{props.children}</>;
}
